module.exports = __webpack_public_path__ + "static/media/Complaints-Procedure.587a7cc8.pdf";